import React from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { Globe } from 'lucide-react';

export default function LangToggle({ dark = false }) {
  const { lang, setLang } = useI18n();
  const next = lang === 'en' ? 'es' : 'en';
  const label = lang === 'en' ? 'EN' : 'ES';
  const base = dark ? 'text-[#f5efe3]/90 hover:text-white' : 'text-[#1f3a2a]/80 hover:text-[#1f3a2a]';
  return (
    <button
      onClick={() => setLang(next)}
      aria-label="Toggle language"
      data-testid="lang-toggle-btn"
      className={`inline-flex items-center gap-1.5 text-xs font-medium tracking-wider uppercase rounded-full border px-3 h-9 transition-colors ${base} ${dark ? 'border-[#f5efe3]/25 hover:border-[#d4a63d]' : 'border-[#1f3a2a]/20 hover:border-[#1f3a2a]'}`}
    >
      <Globe size={14} /> {label}
    </button>
  );
}
